import { Link } from 'react-router-dom';
import { brandInfo } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-secondary-950">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-circle-fill text-xl text-background-50"></i>
              </div>
              <span className="text-lg font-bold text-background-50 whitespace-nowrap font-heading tracking-wide">蜜桃传媒</span>
            </div>
            <p className="text-sm text-secondary-300 leading-relaxed">
              精彩视界，触手可及。蜜桃传媒为您提供海量高清视频内容，随时随地畅享视听盛宴。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">快速导航</h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/hot" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">热门推荐</Link>
              <Link to="/category/latest" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">最新上映</Link>
              <Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">内容分类</h4>
            <div className="flex flex-col gap-3">
              <Link to="/category/domestic" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">国产精品</Link>
              <Link to="/category/asia" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">亚洲专区</Link>
              <Link to="/category/western" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">欧美大片</Link>
              <Link to="/category/anime" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">动漫卡通</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">联系我们</h4>
            <div className="flex flex-col gap-3 text-sm text-secondary-300">
              <span className="whitespace-nowrap">邮箱：{brandInfo.contact.email}</span>
              <span className="whitespace-nowrap">电话：{brandInfo.contact.phone}</span>
              <span className="leading-relaxed">地址：{brandInfo.contact.address}</span>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto mt-12 pt-8 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400 whitespace-nowrap">
            &copy; {new Date().getFullYear()} 蜜桃传媒 版权所有 | 京ICP备2024XXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:text-primary-400 hover:bg-secondary-700 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:text-primary-400 hover:bg-secondary-700 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-sm"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:text-primary-400 hover:bg-secondary-700 transition-colors cursor-pointer" aria-label="邮箱">
              <i className="ri-mail-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}